export const DASHBOARD_TABLE_ROW_HOVER_BG_CLASS = 'hover:bg-muted/40';

/** Opaque equivalent of muted/40 over card — required for sticky cells over scrolled content. */
export const DASHBOARD_TABLE_STICKY_ROW_HOVER_BG_CLASS =
  'group-hover:bg-[color-mix(in_srgb,var(--color-muted)_40%,var(--color-card))]';

export const DASHBOARD_TABLE_HEADER_HEIGHT_PX = 40;
export const DASHBOARD_TABLE_HEADER_HEIGHT_CLASS = 'h-10';

export const DASHBOARD_TABLE_Z_INDEX = {
  SCROLL_OVERLAYS: 50,
  STICKY_COLUMN_HEADER: 40,
  STICKY_HEADER: 20,
  STICKY_COLUMN_BODY: 10,
} as const;
